import { useMemo } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Tab, Tabs } from '@mui/material'

import { AdminEstablishmentTabEnum, useEstablishmentTab } from '../model/useEstablishmentTab'

type EstablishmentTabConfig = {
  id: string
  label: string
  value: AdminEstablishmentTabEnum
}

export function EstablishmentTabs() {
  const lingui = useLingui()
  const [tab, setTab] = useEstablishmentTab()
  const tabs = useMemo<EstablishmentTabConfig[]>(
    () => [
      { id: 'edit', label: lingui._(t`Edit`), value: AdminEstablishmentTabEnum.EDIT },
      { id: 'plugins', label: lingui._(t`Plugins`), value: AdminEstablishmentTabEnum.PLUGINS },
    ],
    [lingui]
  )

  return (
    <Tabs value={tab} onChange={(_event, newValue) => setTab(newValue)} variant="scrollable">
      {tabs.map((tabItem) => (
        <Tab key={tabItem.id} label={tabItem.label} value={tabItem.value} />
      ))}
    </Tabs>
  )
}
